import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import Layout from "./components/Layout/Layout";
import Dashboard from "./pages/Dashboard/Dashboard";
import Finance from "./pages/Finance/Finance";
import HR from "./pages/HR/HR";
import Procurement from "./pages/Procurement/Procurement";
import ClinicalOps from "./pages/ClinicalOps/ClinicalOps";
import Billing from "./pages/Billing/Billing";
import Facilities from "./pages/Facilities/Facilities";
import CRM from "./pages/CRM/CRM";
import Analytics from "./pages/Analytics/Analytics";
import Compliance from "./pages/Compliance/Compliance";
import MultiEntity from "./pages/MultiEntity/MultiEntity";
import Login from "./pages/Auth/Login";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { NotificationProvider } from "./components/common/NotificationProvider";

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(true); // Demo mode

  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <ErrorBoundary>
      <NotificationProvider>
        <Box sx={{ display: "flex" }}>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/hr" element={<HR />} />
              <Route path="/procurement" element={<Procurement />} />
              <Route path="/clinical" element={<ClinicalOps />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/facilities" element={<Facilities />} />
              <Route path="/crm" element={<CRM />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/multi-entity" element={<MultiEntity />} />
            </Routes>
          </Layout>
        </Box>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;
